'use strict';

var base = require('base/product/base');
var coreBase = require('core/product/base');
var focusHelper = require('base/components/focus');
var summaryHelpers = require('../checkout/summary');
/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
// CART TOOLTIP SCRIPT
$(document).ready(function () {
    checkDate();
    changeProductQuantity();
    disableCheckForCartAddButtonsOnMinicartOpen();
});

function disableCheckForCartAddButtonsOnMinicartOpen() {
    // Get input elements and buttons
    var inputs = $('.quantityChangeMinicart');
    var subBtn = $('.sub-minicart');
    var addBtn = $('.add-minicart');

    // Get values and iterate through them
    var values = inputs.map(function () {
        // Get the value of the attribute for each input
        var min = $(this).attr('data-minimum');
        var max = $(this).attr('data-available');
        return {
            value: parseInt($(this).val(), 10),
            min: min,
            max: max
        };
    }).get();

    values.forEach(function (item, index) {
        if (item.value == item.min) {
            $(inputs[index]).prev(subBtn).addClass('btn-qty-disabled');
        }

        if (item.value == item.max) {
            $(inputs[index]).next(addBtn).addClass('btn-qty-disabled');
        }
    });
}

function changeProductQuantity() {
    $('.quantity.custom-select').on('input', function () {
        checkDate();
    });
}

$(document).ready(function () {
    var cardBannerContainer = $('.card-banner-PLP');
    if (cardBannerContainer.children().length > 0) {
        cardBannerContainer.removeClass('d-none');
    } else {
        cardBannerContainer.addClass('d-none');
    }
});

function checkDate() {
    let tooltipClose = localStorage.getItem('tooltipClosingTime');
    if (tooltipClose) {
        let now = new Date();
        let diff = now - new Date(tooltipClose);
        let hours = diff / 1000 / 60 / 60;
        if (hours >= 1) {
            // 2 hours or more have passed
            $('.tooltip-FreeShipping .tooltiptext-FreeShipping').removeClass(
                'd-none'
            );
        } else {
            // 2 hours have not passed
            $('.tooltip-FreeShipping .tooltiptext-FreeShipping').addClass(
                'd-none'
            );
        }
    } else {
        $('.tooltip-FreeShipping .tooltiptext-FreeShipping').removeClass(
            'd-none'
        );
    }
}

function appendToUrl(url, params) {
    var newUrl = url;
    newUrl +=
        (newUrl.indexOf('?') !== -1 ? '&' : '?') +
        Object.keys(params)
            .map(function (key) {
                return key + '=' + encodeURIComponent(params[key]);
            })
            .join('&');

    return newUrl;
}

function tooltipHover() {
    $(".info-icon").on("mouseenter focusin", function () {
        $(this).find(".tooltip").removeClass("d-none");
    });

    $(".info-icon").on("mouseleave focusout", function () {
        $(this).find(".tooltip").addClass("d-none");
    });
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error && !data.valid.removedProductsData) {
        if (data.valid.message) {
            var errorHtml =
                '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' +
                data.valid.message +
                '</div>';
            var errorMsgCart = $('.cart-error .valid-cart-error').length;
            if (errorMsgCart === 0) {
                $('.cart-error').append(errorHtml);
            }
            $('#cartItems').load(' #cartItems');
            $('#miniCartItems').load(' #miniCartItems');
        } else {
            $('.cart')
                .empty()
                .append(
                    '<div class="row"> ' +
                    '<div class="col-12 text-center"> ' +
                    '<i class="fa fa-2x fa-shopping-bag"></i>' +
                    '<h1 class="cart-empty-text">' +
                    data.resources.emptyCartMsg +
                    '</h1> ' +
                    '</div> ' +
                    '</div>'
                );
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        const enableStoreSelector =$('[name="enableStoreSelector"]').val() === "true";
        if (data.isMethodComplete && enableStoreSelector) {
            $(".checkout-btn").removeClass("disabled");
        }
    }
}

/*
 * Remove the displays error message and disables
 * close button cart/minicart
 */

$('body').on('click', '.alert-dismissible.valid-cart-error button', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.alert-dismissible.valid-cart-error').remove();
});

function updateItemOptionsTotals(item) {
    if (item.options) {
        item.options.forEach(function (option) {
            $('.' + option.optionId + '-total-' + item.UUID)
                .empty()
                .append(
                    '+$' +
                    option.priceValue.toLocaleString('es', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })
                );
        });
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    // A revisar
    // var totalShippingCost = data.totals.totalShippingCost.replace(/[$.]/g, "").replace(",", ".");
    // console.log(totalShippingCost)
    if (data.totals.totalShippingCost > 0) {
        $('.shipment-cost-container').removeClass('d-none');
        $('.shipping-cost')
            .empty()
            .append('<span>' + data.totals.totalShippingCost + '</span>');
    } else {
        $('.shipment-cost-container').addClass('d-none');
    }
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.tax-total-disc').empty().append(data.totals.totalPriceNoTaxes);
    $('.grand-total')
        .empty()
        .append('<span>' + data.totals.grandTotal + '</span>');
    $('.sub-total')
        .empty()
        .append('<span>' + data.totals.subTotal + '</span>');
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });

    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('d-none');
        $('.order-discount-total')
            .empty()
            .append(
                '<span>- ' +
                data.totals.orderLevelDiscountTotal.formatted +
                '</span>'
            );
    } else {
        $('.order-discount').addClass('d-none');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 1) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total')
            .empty()
            .append(
                '<span>- ' +
                data.totals.shippingLevelDiscountTotal.formatted +
                '</span>'
            );
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    $('.normal-shipping-cost')
        .empty()
        .append('<span>' + data.totals.totalShippingCost + '</span>');

    data.items.forEach(function (item) {
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        if (item.priceTotal && item.priceTotal.renderedPrice) {
            $('.item-total-' + item.UUID)
                .empty()
                .append(item.priceTotal.renderedPrice);
        }

        if (item.priceTotalnoTax) {
            $('.total-price-no-tax-' + item.UUID)
                .empty()
                .append(item.priceTotalnoTax);
        }

        if (item.price.sales) {
            $('.total-united-price-' + item.UUID)
                .empty()
                .append(item.price.sales.formatted);
        }

        updateItemOptionsTotals(item);
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml =
        '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        message +
        '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var spansTextElement = document.querySelector('.approaching-discounts .spans-text');

    if (!spansTextElement) {
        return; // Si no existe el elemento, salir de la función.
    }

    var html = '';
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += item.discountMsg;
        });
        spansTextElement.innerHTML = html;
        $('.approaching-discounts').removeClass('d-none');
    } else {
        $('.approaching-discounts').addClass('d-none');
    }
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    $('.availability-' + lineItem.UUID).empty();

    if (lineItem.availability) {
        if (lineItem.availability.messages) {
            lineItem.availability.messages.forEach(function (message) {
                messages +=
                    '<p class="line-item-attributes">' + message + '</p>';
            });
        }

        if (lineItem.availability.inStockDate) {
            messages +=
                '<p class="line-item-attributes line-item-instock-date">' +
                lineItem.availability.inStockDate +
                '</p>';
        }
    }

    $('.availability-' + lineItem.UUID).html(messages);
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    var lineItem = findItem(data.cartModel.items, function (item) {
        return item.UUID === uuid;
    });

    if (lineItem.variationAttributes) {
        var colorAttr = findItem(lineItem.variationAttributes, function (attr) {
            return attr.attributeId === 'color';
        });

        if (colorAttr) {
            var colorSelector = '.Color-' + uuid;
            var newColor = 'Color: ' + colorAttr.displayValue;
            $(colorSelector).text(newColor);
        }

        var sizeAttr = findItem(lineItem.variationAttributes, function (attr) {
            return attr.attributeId === 'size';
        });
        // NET-951 START
        if (sizeAttr) {
            var sizeSelector = '.Talle-' + uuid;
            var newSize = 'Talle: ' + sizeAttr.displayValue;
            $(sizeSelector).text(newSize);
        }
        // NET-951 END
        var productIdCart = '.IdProduct-' + uuid;
        var newProductId = 'Item No.: ' + lineItem.id;
        $(productIdCart).text(newProductId);

        var imageSelector =
            '.card.product-info.uuid-' + uuid + ' .item-image > img';
        $(imageSelector).attr('src', lineItem.images.small[0].url);
        $(imageSelector).attr('alt', lineItem.images.small[0].alt);
        $(imageSelector).attr('title', lineItem.images.small[0].title);
    }

    if (lineItem.options && lineItem.options.length) {
        var option = lineItem.options[0];
        var optSelector =
            '.lineItem-options-values[data-option-id="' +
            option.optionId +
            '"]';
        $(optSelector).data('value-id', option.selectedValueId);
        $(optSelector + ' .line-item-attributes').text(option.displayName);
    }

    var qtySelector = '.quantity[data-uuid="' + uuid + '"]';
    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).data('pid', data.newProductId);

    $('.remove-product[data-uuid="' + uuid + '"]').data(
        'pid',
        data.newProductId
    );

    var priceSelector = '.line-item-price-' + uuid + ' .sales .value';
    $(priceSelector).text(lineItem.price.sales.formatted);
    $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

    if (lineItem.price.list) {
        var listPriceSelector = '.line-item-price-' + uuid + ' .list .value';
        $(listPriceSelector).text(lineItem.price.list.formatted);
        $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
    }
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement(productUrl) {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog quick-view-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <a href="' +
        productUrl +
        '">Ir a la Página de Producto</a>' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return {
        body: body,
        footer: footer
    };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);
            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(
                data.closeButtonText
            );
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

function eventListenerRemovePWS() {
    $('.popover-bottom').hover(function () {
        if ($('#pwsId').length > 0) {
            var pwsInfo = JSON.parse($('#pwsId').val()).productsWithoutStock;
            var url = $('.remove-btn').data('action');
            for (let index = 0; index < pwsInfo.length; index++) {
                var urlParams = {
                    pid: pwsInfo[index].sku,
                    uuid: pwsInfo[index].uuid
                };
                url = appendToUrl(url, urlParams);
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    // eslint-disable-next-line no-loop-func
                    success: function (info) {
                        if (info.basket.items.length === 0) {
                            $(".cart")
                                .empty()
                                .append(
                                    '<div class="row"> ' +
                                        '<div class="col-12 text-center"> ' +
                                        '<i class="fa fa-2x fa-shopping-bag"></i>' +
                                        '<h1 class="cart-empty-text">' +
                                        info.basket.resources.emptyCartMsg +
                                        "</h1> " +
                                        "</div> " +
                                        "</div>"
                                );
                            $(".cart").addClass("cart-empty");
                            $(".number-of-items")
                                .empty()
                                .append(info.basket.resources.numberOfItems);
                            $(".minicart-quantity").empty().addClass("d-none");
                            $(".minicart-quantity-d-none").removeClass(
                                "d-none"
                            );
                            $(".minicart-link").attr({
                                "aria-label":
                                    info.basket.resources.minicartCountOfItems,
                                title: info.basket.resources
                                    .minicartCountOfItems,
                            });
                            $(".minicart .popover").empty();
                            $("body").removeClass("modal-open");
                            $("html").removeClass("veiled");
                        } else {
                            if (
                                info.toBeDeletedUUIDs &&
                                info.toBeDeletedUUIDs.length > 0
                            ) {
                                for (
                                    var i = 0;
                                    i < info.toBeDeletedUUIDs.length;
                                    i++
                                ) {
                                    $(
                                        ".uuid-" + info.toBeDeletedUUIDs[i]
                                    ).remove();
                                }
                            }
                            $(".uuid-" + urlParams.uuid).remove();
                            if (!info.basket.hasBonusProduct) {
                                $(".bonus-product").remove();
                                $("#cartItems").load(" #cartItems");
                                $("#miniCartItems").load(" #miniCartItems");
                            }
                            $(".coupons-and-promos")
                                .empty()
                                .append(info.basket.totals.discountsHtml);
                            updateCartTotals(info.basket);
                            updateApproachingDiscounts(
                                info.basket.approachingDiscounts
                            );
                            $("body").trigger(
                                "setShippingMethodSelection",
                                info.basket
                            );
                            validateBasket(info.basket);
                        }

                        $("body").trigger("cart:update");

                        /* NET-939 BEGIN */
                        // Sending remove_from_cart Event GA4 AZ-19664
                        if (info.removeFromCartGtmEvent) {
                            var removeFromCartGtmEvent = JSON.parse(info.removeFromCartGtmEvent);

                            if (typeof removeFromCartGtmEvent === "object" && removeFromCartGtmEvent !== null) {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(removeFromCartGtmEvent);
                            }
                        }
                        /* NET-939 END */

                        $.spinner().stop();
                    },
                    error: function (err) { }
                });
            }
            $.spinner().stop();
        }
    });
}

// Sending view_cart Event GA4 AZ-19664
function sendCartGTMEvent() {
    var cartGtmEvent = $("#cartGtmEvent").val();
    var gtmCartEvent = cartGtmEvent ? JSON.parse(cartGtmEvent) : null;
    if (typeof gtmCartEvent === "object" && gtmCartEvent !== null) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        window.dataLayer.push(gtmCartEvent);
    }
}

// PopUp recommended Products
var promotionRecommended = $('#promotionRecommended').val();
if (promotionRecommended !== 'false') {
    $('.modal-recommendation').show().addClass('show');
} else {
    $('.modal-recommendation').hide();
}

/**
 * Append html about discount coupon information
 * @param {Object} data 
 */
function setAppliedCouponAttribute(data) {
    $('.coupons-and-promos')
        .empty()
        .append(data.totals.discountsHtml);
}

/**
 * In Qurable coupons this function modifies classes to display "applied" label in cart coupon card
 * @param {Object} data 
 */
function setQurableAppliedCouponAttribute(data) {
    var $couponElement = $('.coupon-not-applied');

    $couponElement
        .text('Aplicado')
        .removeClass('coupon-not-applied')
        .addClass('coupon-applied');
}

/**
 * Hide coupon messages
 */
function hideCouponMessages() {
    $('.coupon-error-message').empty();
    $('.coupon-success-message').empty();
    $('.coupon-missing-error').hide();
}

function deleteShippingSelection(data) {
    $('[data-js-hd-stock]').empty().text(data.warehouseStockMsg);
    $('[data-js-cc-stock]').empty().text(data.storesStockMsg);
    
    var homeDeliveryBtn = $('[data-js-hd-btn]');
    var clickAndCollectBtn = $('[data-js-cc-btn]');
    var homeDeliverySpan = $('[data-js-hd-stock]');
    var clickAndCollectSpan = $('[data-js-cc-stock]');
    var addToCartPdpBtn = $('[data-js-pdp-add-to-cart-button]');
    var selectStorePdpBtn= $('[data-js-pdp-select-store-cc-button]');
    var isValidShippingMethod = !data.invalidCcAndHdMix && ((data.isOnlyInWarehouse && !data.isCcShipment || data.isOnlyInStores && data.isCcShipment) || (!data.isOnlyInStores && !data.isOnlyInWarehouse));

    if (data.selectedVariant) {
        homeDeliveryBtn.toggleClass('m-active_method', data.selectedOptionHd);
        clickAndCollectBtn.toggleClass('m-active_method', data.selectedOptionCc);

        homeDeliveryBtn.toggleClass('m-sm_disabled', !data.warehouseStock);
        clickAndCollectBtn.toggleClass('m-sm_disabled', !data.storesStock);

        homeDeliverySpan.toggleClass('m-has_stock', data.warehouseStock);
        homeDeliverySpan.toggleClass('m-hasnt_stock', !data.warehouseStock);

        clickAndCollectSpan.toggleClass('m-has_stock', data.storesStock);
        clickAndCollectSpan.toggleClass('m-hasnt_stock', !data.storesStock);

        addToCartPdpBtn.toggleClass('d-none', data.ccAndEmptyBasket);
        selectStorePdpBtn.toggleClass('d-none', !data.ccAndEmptyBasket);

    } else {
        homeDeliveryBtn.removeClass('m-sm_disabled');
        clickAndCollectBtn.removeClass('m-sm_disabled');

        homeDeliverySpan.removeClass('m-has_stock');
        homeDeliverySpan.removeClass('m-hasnt_stock');

        clickAndCollectSpan.removeClass('m-has_stock');
        clickAndCollectSpan.removeClass('m-hasnt_stock');
    }

    $('[data-js-selected-method-container]').toggleClass('d-none', !isValidShippingMethod || data.emptyBasket);
    $('[data-js-unavailable-method-container]').toggleClass('d-none', isValidShippingMethod || data.emptyBasket);

    $('[data-js-cc-icon]').attr('xlink:href', data.ccIcon);
    $('[data-js-hd-icon]').attr('xlink:href', data.hdIcon);

    if (data.emptyBasket) {
        $('[data-js-selected-method]').empty();
    }

    if ((!data.storesStock && !data.warehouseStock) && !data.emptyBasket) {
        $('#btn-add-to-cart').addClass('disabled');
        $('#btn-add-to-cart').prop('disabled', true);
        $('[data-js-unavailable-method-container]').addClass('d-none');
        $('[data-js-selected-method-container]').addClass('d-none');
        $('[data-js-error-no-available-method]').removeClass('d-none');
    }
    
    if (((data.storesStock && data.selectedOptionCc)
        || (data.warehouseStock && data.selectedOptionHd))
        || data.emptyBasket) {
        $('[data-js-error-no-available-method]').addClass('d-none');
        $('#btn-add-to-cart').removeClass('disabled');
        $('#btn-add-to-cart').removeAttr('disabled');
        $('[data-js-quantity-selector-input]').val('1');
    }

    if (!data.emptyBasket 
        && (data.selectedOptionCc || data.selectedOptionHd)
        && !isValidShippingMethod) {
        $('#btn-add-to-cart').addClass('disabled');
        $('#btn-add-to-cart').prop('disabled', true);
    }

    if (!data.selectedOptionCc && !data.selectedOptionHd) {
        $('[data-js-selected-method-container]').addClass('d-none');
        $('[data-js-unavailable-method-container]').addClass('d-none');
        
        if (data.storesStock || data.warehouseStock) {
            $('[data-js-error-no-available-method]').addClass('d-none');
        }

        if (data.isOnlyInStores) {
            $('#btn-add-to-cart').removeClass('disabled');
            $('#btn-add-to-cart').removeAttr('disabled');
            $('[data-js-pdp-add-to-cart-button]').addClass('d-none');
            $('[data-js-pdp-select-store-cc-button]').removeClass('d-none');
        }
    }

    if (data.storesStock && !data.warehouseStock && data.selectedOptionCc) {
        $('[data-js-pdp-add-to-cart-button]').toggleClass('d-none', !data.haveStockInSelectedStore);
        $('[data-js-pdp-select-store-cc-button]').toggleClass('d-none', data.haveStockInSelectedStore);
    }
}

function setMaxQuantityProduct(data) {
    if (data.setMaxQty) {
        $('[data-js-quantity-selector-input]').prop('max', data.maxQty);
        $('[data-js-quantity-selector-input]').attr("data-available", data.maxQty);
    }
}

module.exports = function () {
    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        confirmDelete(actionUrl, productID, productName, uuid);
        setTimeout(() => {
            if ($('#removeProductModal').hasClass('show') && window.innerWidth < 545) {
                $('.minicart-mobile-delete-button').removeClass('hidden-xs-down');
            }
        }, 1000);
    });

    $('body').on('click', '.approaching-discounts .close-btn', function (e) {
        e.preventDefault();

        $('.approaching-discounts').addClass('d-none');
        let now = new Date();
        localStorage.setItem('tooltipClosingTime', now);
    });

    $('body').on('product:afterAddToCart', function (e, data) {
        // Si el add falló (stock insuficiente, mixed origin, método incompleto),
        // no tocar el badge del minicart ni disparar el evento de analytics —
        // el basket no cambió.
        if (data.error) {
            return;
        }

        $('.minicart-quantity').removeClass('d-none');
        $('.minicart-quantity-d-none').addClass('d-none');
        /* NET-939 BEGIN */
        // Sending add_to_cart Event GA4 AZ-19664
        if (data.addToCartGtmEvent) {
            var addToCartGtmEvent = JSON.parse(data.addToCartGtmEvent);
            if (
                typeof addToCartGtmEvent === "object" &&
                addToCartGtmEvent !== null
            ) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push(addToCartGtmEvent);
            }
        }
        /* NET-939 END */
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(
            data.actionUrl,
            data.productID,
            data.productName,
            data.uuid
        );
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();
        var $deleteModal = $(this).closest('.modal');

        function focusEmptyCartMessage() {
            var $target = $(".cart-empty-text").first();

            if (!$target.length) {
                $target = $(".minicart-link:visible").first();
            }

            if ($target.length) {
                $target.trigger("focus");
            }
        }

        function focusEmptyCartMessageWhenReady() {
            if (
                !$deleteModal.length ||
                !document.body.contains($deleteModal[0]) ||
                !$deleteModal.hasClass("show")
            ) {
                focusEmptyCartMessage();
                return;
            }

            var done = false;
            var run = function () {
                if (done) {
                    return;
                }
                done = true;
                focusEmptyCartMessage();
            };

            $deleteModal.one("hidden.bs.modal", run);
            setTimeout(run, 500);
        }

        var selectedVariant = $('.variation-attribute-size.wrapper.selected');
        var selectedVariantSku = selectedVariant.data('sku') || '';
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid,
            selectedVariantSku: selectedVariantSku
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.tooltip-clickandcollect.one, .tooltip-clickandcollect.two').addClass('d-none');
                $('#btn-cart-modal-click-and-collect').addClass('d-none');
                $('#btn-add-to-cart').removeClass('d-none');
                if (data.basket.items.length === 0) {
                    $('.cart')
                        .empty()
                        .append(
                            '<div class="row"> ' +
                            '<div class="col-12 text-center"> ' +
                            '<i class="fa fa-2x fa-shopping-bag"></i>' +
                            '<h1 class="cart-empty-text" tabindex="-1">' +
                            data.basket.resources.emptyCartMsg +
                            '</h1> ' +
                            '</div> ' +
                            '</div>'
                        );
                    $('.cart').addClass('cart-empty');
                    $('.number-of-items')
                        .empty()
                        .append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().addClass('d-none');
                    $('.minicart-quantity-d-none').removeClass('d-none');
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');

                    $('[data-js-error-no-available-method]').addClass('d-none');
                    $('#btn-add-to-cart').removeClass('disabled');
                    $('#btn-add-to-cart').removeAttr('disabled');
                    $('[data-js-quantity-selector-input]').val('1');
                    $('[data-js-quantity-selector-input]').prop('max');

                    focusEmptyCartMessageWhenReady();

                } else {
                    if (
                        data.toBeDeletedUUIDs &&
                        data.toBeDeletedUUIDs.length > 0
                    ) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.basket.totals.discountsHtml);
                    setAppliedCouponAttribute(data.basket);
                    if (data.basket.isQurableCoupon) setQurableAppliedCouponAttribute(data);
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(
                        data.basket.approachingDiscounts
                    );
                    $('body').trigger(
                        'setShippingMethodSelection',
                        data.basket
                    );
                    validateBasket(data.basket);
                }

                if (!data.isEmptyProductVariant) {
                    deleteShippingSelection(data.basketStockData);
                    setMaxQuantityProduct(data.maxProductQty);
                }

                // El servidor limpió la sucursal elegida porque el carrito quedó vacío
                // (data.storeClearedGtmEvent solo viene en ese caso). Se avisa a la
                // página para que deje de mostrarla (ej. el selector de entrega de la
                // PDP, cuando se borra desde el minicart).
                if (data.storeClearedGtmEvent) {
                    $('body').trigger('cart:store-cleared', [data]);
                }

                $('body').trigger('cart:update');

                /* NET-939 BEGIN */
                // Sending remove_from_cart Event GA4 AZ-19664
                if (data.removeFromCartGtmEvent) {
                    var removeFromCartGtmEvent = JSON.parse(data.removeFromCartGtmEvent);
                    if (typeof removeFromCartGtmEvent === "object" && removeFromCartGtmEvent !== null) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push(removeFromCartGtmEvent);
                    }
                }
                /* NET-939 END */

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('change', '.quantity-form > .quantity, .quantityChangeMinicart', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                setAppliedCouponAttribute(data);
                if (data.isQurableCoupon) setQurableAppliedCouponAttribute(data);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                $(this).data('pre-select-qty', quantity);
                $('body').trigger('cart:update');

                $.spinner().stop();
                if (
                    $(this)
                        .parents('.product-info')
                        .hasClass('bonus-product-line-item') &&
                    $('.cart-page').length
                ) {
                    location.reload();
                }
                tooltipHover();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };

        $('.totals').spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        hideCouponMessages();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr(
                'aria-describedby',
                'missingCouponCode'
            );
            $('.coupon-missing-error').show();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $.spinner().start();
        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr(
                        'aria-describedby',
                        'invalidCouponCode'
                    );
                    $('.coupon-error-message').empty().append(data.errorMessage);

                } else {
                    setAppliedCouponAttribute(data);
                    if (data.isQurableCoupon) {
                        setQurableAppliedCouponAttribute(data);
                        $(".coupon-success-message")
                            .empty()
                            .append(data.qurableSuccessCouponMsg);
                    }
                    // Updates CheckoutTotals - Coupons Add
                    var currentStage = $(".data-checkout-stage").data(
                        "checkout-stage"
                    );
                    if (currentStage) {
                        summaryHelpers.updateTotals(data.totals);
                        summaryHelpers.updateProductsTotals(data.items)
                    } else {
                        updateCartTotals(data);
                    }
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                var currentStage = $(".data-checkout-stage").data(
                    "checkout-stage"
                );
                // Updates CheckoutTotals - Coupons Remove
                if (currentStage) {
                    summaryHelpers.updateTotals(data.totals);
                    summaryHelpers.updateProductsTotals(data.items);
                } else {
                    updateCartTotals(data);
                }
                updateApproachingDiscounts(data.approachingDiscounts);
                hideCouponMessages();
                validateBasket(data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                coreBase.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on(
        'click',
        '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit',
        function (e) {
            e.preventDefault();
        }
    );

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on(
        'hidden.bs.modal',
        '#editProductModal, #quickViewModal',
        function () {
            $('#editProductModal').siblings().attr('aria-hidden', 'false');
            $('#editProductModal .modal-body').empty();
            $('#quickViewModal .modal-body').empty();
        }
    );

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer).closest(
            '.quick-view-dialog'
        );

        $('.update-cart-product-global', dialog).attr(
            'disabled',
            !$('.global-availability', dialog).data('ready-to-order') || !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer).closest(
            '.quick-view-dialog'
        );

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog)
                .toArray()
                .every(function (item) {
                    return $(item).data('available');
                });

            var allReady = $('.product-availability', dialog)
                .toArray()
                .every(function (item) {
                    return $(item).data('ready-to-order');
                });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog)
                .empty()
                .html(
                    allReady ?
                        response.message :
                        response.resources.info_selectforstock
                );
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show')
                .find(response.container)
                .data('pid', response.data.product.id);
            $('.modal.show')
                .find(response.container)
                .find('.product-id')
                .text(response.data.product.id);
        } else {
            $(response.container).data(
                'pid',
                response.data.product.id
            );
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data(
            'selected-quantity',
            selectedQuantity
        );
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this)
            .children('option:selected')
            .data('value-id');
        $('.modal.show .update-cart-url').data(
            'selected-option',
            selectedOptionValueId
        );
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .val();
        var selectedQuantity = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .data('selected-quantity');
        var selectedOptionValueId = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .data('selected-option');
        var uuid = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();
        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal, #quickViewModal').modal('hide');

                    $('.coupons-and-promos')
                        .empty()
                        .append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(
                        data.cartModel.approachingDiscounts
                    );
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update');

                    $.spinner().stop();
                    location.reload();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    base.selectAttribute();
    coreBase.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    coreBase.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
    eventListenerRemovePWS();
    sendCartGTMEvent();
};
